export const articles = [
  {
    id: 1,
    slug: 'yindao-jiegou-jiepou',
    title: '女性阴道解剖结构详解：认识你的身体',
    excerpt: '全面了解女性阴道的解剖结构，包括阴道壁、阴道口、处女膜等关键部位的生理功能和位置关系，帮助你科学认识自己的身体。',
    category: 'shengli-jiegou',
    image: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20medical%20illustration%20of%20female%20reproductive%20anatomy%20with%20warm%20pastel%20peach%20and%20cream%20background%2C%20elegant%20line%20art%20style%2C%20gentle%20feminine%20aesthetic%2C%20clean%20design%2C%20subtle%20warm%20lighting%2C%20educational%20yet%20artistic%20composition&width=800&height=500&seq=article-anatomy-01&orientation=landscape',
    readTime: 8,
    publishedAt: '2026-07-15',
    content: '',
  },
  {
    id: 2,
    slug: 'yindao-junqun-pingheng',
    title: '阴道菌群平衡：私密健康的守护神',
    excerpt: '阴道内存在大量有益菌群，其中乳酸杆菌是维持阴道健康的关键。了解菌群平衡的重要性和破坏菌群平衡的常见行为。',
    category: 'shengli-jiegou',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20healthy%20microbiome%20flora%20with%20soft%20warm%20coral%20and%20cream%20colors%2C%20flowing%20organic%20shapes%2C%20feminine%20gentle%20aesthetic%2C%20minimalist%20design%2C%20clean%20composition%2C%20soft%20diffused%20lighting&width=800&height=500&seq=article-flora-02&orientation=landscape',
    readTime: 6,
    publishedAt: '2026-07-20',
    content: '',
  },
  {
    id: 3,
    slug: 'yindao-ph-zhi',
    title: '阴道pH值与健康：酸碱平衡的重要性',
    excerpt: '正常阴道环境呈弱酸性，pH值在3.8-4.5之间。这种酸性环境是抵御病原体入侵的第一道防线。了解pH值变化的信号意义。',
    category: 'shengli-jiegou',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20scientific%20illustration%20of%20pH%20balance%20concept%20with%20warm%20peach%20and%20soft%20cream%20tones%2C%20clean%20geometric%20shapes%2C%20feminine%20design%20aesthetic%2C%20gentle%20lighting%2C%20modern%20medical%20art%20style&width=800&height=500&seq=article-ph-03&orientation=landscape',
    readTime: 7,
    publishedAt: '2026-07-25',
    content: '',
  },
  {
    id: 4,
    slug: 'si-chu-qingjie-zhengque',
    title: '私处清洁的正确方法：远离护理误区',
    excerpt: '很多女性在私处清洁上存在误区。过度清洁、使用碱性洗液等行为反而会破坏阴道自洁功能。学会科学正确的清洁方法。',
    category: 'richang-huli',
    image: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20bathroom%20scene%20with%20clean%20white%20towels%20and%20natural%20skincare%20products%2C%20warm%20cream%20tones%2C%20feminine%20aesthetic%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20spa-like%20atmosphere&width=800&height=500&seq=article-cleaning-04&orientation=landscape',
    readTime: 5,
    publishedAt: '2026-07-18',
    content: '',
  },
  {
    id: 5,
    slug: 'yuejing-qi-huli',
    title: '月经期间私密护理全攻略',
    excerpt: '月经期间阴道环境发生变化，抵抗力下降。掌握经期正确的私密护理方法，包括卫生巾选择、更换频率、清洁方式等全方位指导。',
    category: 'richang-huli',
    image: 'https://readdy.ai/api/search-image?query=Gentle%20feminine%20wellness%20scene%20with%20soft%20fabric%20textures%20and%20warm%20ambient%20lighting%2C%20calm%20self-care%20aesthetic%2C%20peach%20and%20cream%20color%20palette%2C%20minimalist%20composition%2C%20comforting%20atmosphere&width=800&height=500&seq=article-period-05&orientation=landscape',
    readTime: 6,
    publishedAt: '2026-08-01',
    content: '',
  },
  {
    id: 6,
    slug: 'neiyi-xuanze-yaodian',
    title: '内衣选择与私密健康：材质、款式的科学建议',
    excerpt: '内衣的选择直接影响私密部位的健康。纯棉材质、适度宽松、勤换洗是基本原则。了解不同材质内衣对阴道环境的影响。',
    category: 'richang-huli',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20display%20of%20soft%20natural%20fabric%20textiles%20in%20warm%20cream%20and%20blush%20tones%2C%20organic%20cotton%20texture%2C%20feminine%20lifestyle%20aesthetic%2C%20soft%20natural%20lighting%2C%20clean%20modern%20composition&width=800&height=500&seq=article-underwear-06&orientation=landscape',
    readTime: 5,
    publishedAt: '2026-08-05',
    content: '',
  },
  {
    id: 7,
    slug: 'yindao-yan-zhonglei',
    title: '阴道炎的种类与区别：霉菌性、细菌性、滴虫性',
    excerpt: '阴道炎是最常见的妇科疾病之一，分为霉菌性、细菌性和滴虫性等多种类型。不同类型症状不同，治疗方法也完全不同，准确识别很关键。',
    category: 'changjian-wenti',
    image: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20medical%20concept%20illustration%20with%20abstract%20organic%20shapes%20in%20warm%20coral%20and%20cream%20tones%2C%20clean%20healthcare%20aesthetic%2C%20feminine%20design%2C%20gentle%20composition%2C%20modern%20wellness%20theme&width=800&height=500&seq=article-vaginitis-07&orientation=landscape',
    readTime: 10,
    publishedAt: '2026-07-10',
    content: '',
  },
  {
    id: 8,
    slug: 'fenmiwu-yichang-panduan',
    title: '阴道分泌物异常判断指南：颜色、气味、质地',
    excerpt: '正常的阴道分泌物为白色或透明、无味或微酸。当颜色变黄、变绿，或出现异味、豆腐渣样时，需要警惕。学会自我判断分泌物是否正常。',
    category: 'changjian-wenti',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20medical%20self-care%20concept%20with%20soft%20abstract%20forms%20in%20warm%20blush%20and%20cream%20tones%2C%20feminine%20wellness%20aesthetic%2C%20gentle%20lighting%2C%20modern%20health%20education%20theme&width=800&height=500&seq=article-discharge-08&orientation=landscape',
    readTime: 7,
    publishedAt: '2026-07-12',
    content: '',
  },
  {
    id: 9,
    slug: 'yindao-saoyang-yuanyin',
    title: '阴道瘙痒的原因与应对：不只是阴道炎',
    excerpt: '阴道瘙痒是很多女性难以启齿的困扰。除了阴道炎，过敏、激素变化、皮肤病等也可能引起瘙痒。找到根本原因才能有效解决。',
    category: 'changjian-wenti',
    image: 'https://readdy.ai/api/search-image?query=Calming%20minimalist%20wellness%20illustration%20with%20soft%20organic%20shapes%20and%20gentle%20warm%20peach%20tones%2C%20soothing%20feminine%20aesthetic%2C%20clean%20modern%20design%2C%20comforting%20healthcare%20theme&width=800&height=500&seq=article-itching-09&orientation=landscape',
    readTime: 6,
    publishedAt: '2026-07-28',
    content: '',
  },
  {
    id: 10,
    slug: 'fuke-jiancha-xiangmu',
    title: '妇科检查项目全解读：白带常规、HPV、TCT',
    excerpt: '面对妇科检查单上密密麻麻的指标常常一头雾水。详细解读白带常规、HPV检测、TCT筛查等常见妇科检查项目，让你看懂报告单。',
    category: 'jiuyi-zhinan',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20document%20concept%20with%20soft%20abstract%20shapes%20in%20warm%20cream%20and%20blush%20tones%2C%20minimalist%20healthcare%20aesthetic%2C%20feminine%20professional%20design%2C%20gentle%20lighting&width=800&height=500&seq=article-exam-10&orientation=landscape',
    readTime: 9,
    publishedAt: '2026-08-02',
    content: '',
  },
  {
    id: 11,
    slug: 'shenme-shihou-kan-yisheng',
    title: '什么情况下应该去看妇科医生？',
    excerpt: '很多女性不确定自己的症状是否需要就医。了解需要立即就医的警示信号，以及常规妇科检查的建议频率，避免延误病情。',
    category: 'jiuyi-zhinan',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20doctor%20consultation%20concept%20illustration%20with%20soft%20peach%20and%20cream%20tones%2C%20trusting%20healthcare%20aesthetic%2C%20feminine%20gentle%20design%2C%20clean%20modern%20composition&width=800&height=500&seq=article-doctor-11&orientation=landscape',
    readTime: 7,
    publishedAt: '2026-07-30',
    content: '',
  },
  {
    id: 12,
    slug: 'yu-yisheng-goutong-jiqiao',
    title: '与妇科医生沟通的技巧：克服羞耻感',
    excerpt: '面对私密健康问题，很多女性因为羞耻感而不敢详细描述症状。掌握与医生高效沟通的方法，确保获得准确的诊断和治疗。',
    category: 'jiuyi-zhinan',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20consultation%20scene%20illustration%20with%20warm%20coral%20and%20cream%20tones%2C%20supportive%20feminine%20healthcare%20aesthetic%2C%20clean%20modern%20design%2C%20soft%20ambient%20lighting&width=800&height=500&seq=article-communication-12&orientation=landscape',
    readTime: 5,
    publishedAt: '2026-08-08',
    content: '',
  },
];